<script lang="ts">
	import ArticleDisplay from '$lib/components/Blog/ArticleDisplay.svelte';
	import BlogSplide from '$lib/components/Blog/BlogSplide.svelte';
	import Help from '$lib/components/Global/Help.svelte';
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import __ from '$lib/stores/TranslationStore';
	import type { PageData } from './$types';

	export let data: PageData;

	let articlesByCategory: IndexData;

	$: articlesByCategory = data;

	$: ({ carrousel, mainCategory } = articlesByCategory);

	const metas: MetaMap = {
		home: {
			title: 'Gerir Finanças: Poupança, Crédito e Seguros - Poupança no Minuto',
			description:
				'Descubra estratégias eficazes para gerir as suas finanças pessoais com o nosso guia completo. Aprenda a economizar inteligentemente, a escolher as melhores opções de crédito e a proteger o seu património com seguros adequados. Tudo o que você precisa para uma saúde financeira robusta, cortesia da Poupança no Minuto.'
		},
		'credito-habitacao': {
			title: 'Como Conseguir o Melhor Crédito Habitação: Dicas e Estratégia - Poupança no Minuto',
			description:
				'Descubra como garantir as condições mais vantajosas no seu crédito habitação com o nosso guia abrangente. Oferecemos dicas práticas e estratégias eficientes para negociar as taxas, escolher o produto certo e entender os processos. Torne-se um especialista em crédito habitação com a ajuda da Poupança no Minuto.'
		},
		'credito-pessoal': {
			title: 'Dicas Essenciais para Conseguir o Melhor Crédito Pessoal - Poupança no Minuto',
			description:
				'Maximize as suas oportunidades de obter as melhores condições em crédito pessoal com o nosso guia exclusivo. Aprenda a avaliar opções, negociar taxas de juros e entender os termos para fazer escolhas informadas. As dicas essenciais que você precisa, trazidas até si pela Poupança no Minuto'
		},
		imobiliario: {
			title: 'Mercado Imobiliário em Foco: Previsões, Dicas e Oportunidades - Poupança no Minuto',
			description:
				'Descubra as tendências futuras do mercado imobiliário com as nossas análises profundas e identifique oportunidades de investimento promissoras. Obtenha conselhos práticos para comprar, vender e investir em propriedades com maior segurança. Tudo o que necessita para triunfar no mercado imobiliário, apresentado pela Poupança no Minuto.'
		},
		institucional: {
			title:
				'Como gerir as suas finanças: Dicas sobre Poupança, Crédito e Seguros - Poupança no Minuto',
			description:
				'Aprenda a gerir as suas finanças de forma eficaz com os nossos conselhos sobre poupança, crédito e seguros. Descubra estratégias para otimizar as suas economias, escolher as melhores opções de crédito e garantir a proteção adequada com seguros. Tudo o que precisa para uma gestão financeira sábia, cortesia de Poupança no Minuto.'
		},
		poupanca: {
			title:
				'Poupança Descomplicada: Passos Simples para Segurança Financeira" - Poupança no Minuto',
			description:
				'Descubra como simplificar a poupança e alcançar a segurança financeira com passos simples e eficazes. Aprenda estratégias acessíveis para poupar mais, gerir dívidas e proteger o seu futuro financeiro. Torne a poupança uma parte fácil da sua vida, com conselhos de Poupança no Minuto.'
		},
		seguros: {
			title:
				'Seguro de Vida Desmistificado: Guia Completo para Escolher e Beneficiar - Poupança no Minuto',
			description:
				'Entenda tudo sobre seguro de vida com o nosso guia completo. Aprenda a escolher a apólice certa para si e descubra como pode beneficiar ao máximo desta proteção. Descomplicamos os termos e ajudamo-lo a tomar decisões informadas, com a expertise de Poupança no Minuto'
		}
	};

	$: pageMeta = metas[mainCategory.slug];
</script>

<svelte:head>
	<Title content={pageMeta?.title} />
	<Description content={pageMeta?.description} />
</svelte:head>

<BlogSplide articles={carrousel} category={articlesByCategory.mainCategory} />
<main data-sveltekit-preload-data="off" data-sveltekit-reload>
	<ArticleDisplay articles={articlesByCategory} category={articlesByCategory.mainCategory} />
</main>
